module.exports = __webpack_public_path__ + "static/media/shuttle-van.710af4ab.svg";